import * as React from "react";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {Option} from "ts-option";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import AcquisitionChannel from "../../../model/acquisitionChannel/AcquisitionChannel";

interface Props {
	/**
	 * Selected acquisition channel
	 */
	selectedAcquisitionChannelId: Option<string>
	/**
	 * Acquisition channels.
	 */
	acquisitionChannels: AcquisitionChannel[]
	/**
	 * On change
	 */
	onChange: (item: AcquisitionChannel) => any
}

export default class AcquisitionChannelDropdown extends React.PureComponent<Props, {}> {
	render() {
		return (
			<InfoModule icon={Icon.Job} title={"HOW PROSPECT FOUND US?"}>
				<DropDown items={this.props.acquisitionChannels}
						  itemToId={(item: AcquisitionChannel) => item.id}
						  itemToLabel={(item: AcquisitionChannel) => item.name}
						  selectedItemId={this.props.selectedAcquisitionChannelId.orNull}
						  placeholder={"How Prospect found us?"}
						  onSelect={this.props.onChange}
						  autoWidth/>
			</InfoModule>
		);
	}
}

